module.exports = __webpack_public_path__ + "9ac6d9b8b0150803f64e6fc848dd12ac.pdf";